import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmPhoto {
    NewLoading:   (pMessage: string) => dmLoading;
    app:          mlBroker;

    GetInAction:  () => boolean;
    SetInAction:  (pInAction: boolean) => void;

    HotelID:      number;
    RoomTypeID:   number;
    HotelPhotoID: number;
    Filename:     string;
    Verified:     boolean;
    SortOrder:    number;

    Path:         string;

    LangID:       number;
    Description:  string;

    DescriptionByLangID: string[];

    constructor(
         pNewLoading:  (pMessage: string)   => dmLoading
        ,pApp:         mlBroker
        ,pGetInAction: ()                   => boolean
        ,pSetInAction: (pInAction: boolean) => void
        ,pPhotoEntry:  RQService.Ota.GetAllHotelPhotosAndDescriptionsRow
    ) {
        this.NewLoading          = pNewLoading;
        this.app                 = pApp;
        this.GetInAction         = pGetInAction;
        this.SetInAction         = pSetInAction;

        this.HotelID             = pPhotoEntry.HotelID;
        this.RoomTypeID          = pPhotoEntry.RoomTypeID;
        this.HotelPhotoID        = pPhotoEntry.HotelPhotoID;
        this.Filename            = pPhotoEntry.Filename;
        this.Verified            = (pPhotoEntry.Verified >= 5 ? true : false);
        this.SortOrder           = pPhotoEntry.SortOrder;

        this.Path                = encodeURI(
            'https://www.tobook.com/photos/' + this.Filename
        );
                                 
        this.LangID              = pPhotoEntry.LangID;
        this.Description         = pPhotoEntry.Description;

        this.DescriptionByLangID = [];
    }

    public AddDescription(
        pPhotoEntry: RQService.Ota.GetAllHotelPhotosAndDescriptionsRow
    ): void {
        this.DescriptionByLangID[pPhotoEntry.LangID] = pPhotoEntry.Description;
    }

    public ChangeDescriptionLangID(pLangID: number) {
        this.LangID      = pLangID;

        this.Description = this.DescriptionByLangID[
            this.LangID
        ];
    }

    public SaveDescription(): void {
        if (this.GetInAction()) { return; }

        this.SetInAction(true);

        let loading = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            let saveParams = RQParam.OtaEditHotelPhotoDescriptionParams();
            
            saveParams.HotelID      = this.HotelID;
            saveParams.HotelPhotoID = this.HotelPhotoID;
            saveParams.Description  = this.Description.trim();
            saveParams.LangID       = this.LangID;
            
            RQService.Ota.EditHotelPhotoDescription(saveParams).then((result) => {
                this.DescriptionByLangID[
                    this.LangID
                ] = this.Description.trim();
            
                loading.Dismiss();
            
                this.SetInAction(false);
            });
        });
    }

    public AssignPhotoToRoomType(pRoomTypeID: number): void {
        if (this.GetInAction()) { return; }

        this.SetInAction(true);

        let loading      = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            this.RoomTypeID  = pRoomTypeID;
            
            let assignParams = RQParam.OtaAssignHotelPhotoToRoomTypeParams();
            
            assignParams.HotelID      = this.HotelID;
            assignParams.HotelPhotoID = this.HotelPhotoID;
            assignParams.RoomTypeID   = this.RoomTypeID;
            
            RQService.Ota.AssignHotelPhotoToRoomType(assignParams).then((result) => {
                loading.Dismiss();
            
                this.SetInAction(false);
            });
        });
    }
}

export class PhotosViewModel {
    ShowAlert:             (pTitle: string, pMessage: string)                      => void;
    BackToSignIn:          ()                                                      => void;
    NewLoading:            (pMessage: string)                                      => dmLoading;
    ShowConfirmation:      (pTitle: string ,pMessage: string ,pAction: () => void) => void;
    ScrollToBottom:        ()                                                      => void;

    GetInAction:           ()                                                      => boolean;
    SetInAction:           (pInAction: boolean)                                    => void;

    InAction:              boolean;

    mlText:                MLText;
    app:                   mlBroker;
    ml:                    mlBroker;
    Hotel:                 dmHotel;
    LangID:                number;

    NewPhotoFileName:      string;
    NewPhotoDescriptionEN: string;

    FileSelected:          boolean;

    RoomTypesParams = RQParam.PmsGetRoomTypesParams();
    AllPhotosParams = RQParam.OtaGetAllHotelPhotosAndDescriptionsParams();

    Languages:      RQService.Pms.GetLanguagesRow[];
    RoomTypes:      RQService.Pms.GetRoomTypesRow[];
    Photos:         dmPhoto[];

    constructor(
         pMLText:           MLText
        ,pHotel:            dmHotel
        ,pBackToSignIn:     ()                                                        => void
        ,pShowAlert:        (pTitle:   string ,pMessage: string)                      => void
        ,pNewLoading:       (pMessage: string)                                        => dmLoading
        ,pShowConfirmation: (pTitle:   string ,pMessage: string ,pAction: () => void) => void
        ,pScrollToBottom:   ()                                                        => void
    ) {
        this.mlText           = pMLText;
        this.LangID           = this.mlText.GetLangID();
        this.app              = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml               = this.mlText.GetBroker(
            'HotelAreaPhotos'
        );

        this.Hotel            = pHotel;
        this.BackToSignIn     = pBackToSignIn;
        this.ShowAlert        = pShowAlert;
        this.NewLoading       = pNewLoading;
        this.ShowConfirmation = pShowConfirmation;
        this.ScrollToBottom   = pScrollToBottom;

        this.InAction         = false;

        this.GetInAction      = () => {
            return this.InAction;
        };

        this.SetInAction  = (pInAction: boolean) => {
            this.InAction = pInAction;
        };

        this.NewPhotoFileName      = '';
        this.NewPhotoDescriptionEN = '';
        this.FileSelected          = false;

        this.AllPhotosParams.HotelID = this.Hotel.HotelID;
        this.RoomTypesParams.HotelID = this.Hotel.HotelID;
        this.RoomTypesParams.LangID  = this.LangID;

        this.Photos       = [];
        this.Languages    = [];
        this.RoomTypes    = [];

        this.setLanguagesHandler();
        this.setRoomTypesHandler();

        this.SetInAction(true);

        this.populateLanguages(() => {
            this.populateRoomTypes(() => {
                this.refreshPhotos(() => {
                    this.SetInAction(false);
                });
            });
        });
    }

    private setLanguagesHandler(): void {
        RQHandlers.Pms.GetLanguages = (result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let languages = response.RQueryResult;

            this.Languages.length = 0;

            for (let i = 0; i < languages.length; i++) {
                let language = RQService.Pms.PopulateGetLanguagesRow(
                    languages[i]
                );

                console.log('row push');

                this.Languages.push(language);
            }
        };
    }

    private setRoomTypesHandler(): void {
        RQHandlers.Pms.GetRoomTypes = (result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let roomTypes = response.RQueryResult;

            this.RoomTypes.length  = 0;

            let noRoomTypeAssigned = RQService.Pms.PopulateGetRoomTypesRow({}); 

            noRoomTypeAssigned.RoomTypeID   = 0;
            noRoomTypeAssigned.RoomTypeName = this.app.Text(
                 'NoRoomTypeAssigned'
                ,'No Room Type Assigned'
            );

            this.RoomTypes.push(noRoomTypeAssigned);

            for (let i = 0; i < roomTypes.length; i++) {
                let roomType = RQService.Pms.PopulateGetRoomTypesRow(
                    roomTypes[i]
                );

                console.log('row push');

                this.RoomTypes.push(roomType);
            }
        };
    }

    private populateLanguages(pAction: () => void): void {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark' ,'Loading...')
        );

        loading.Show(() => {
            RQService.Pms.GetLanguages(
                {}
            ).then((result) => {
                loading.Dismiss();

                pAction();
            });
        });
    }

    private populateRoomTypes(pAction: () => void): void {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark' ,'Loading...')
        );

        loading.Show(() => {
            RQService.Pms.GetRoomTypes(
                this.RoomTypesParams
            ).then((result) => {
                loading.Dismiss();
            
                pAction();
            });
        });
    }

    private refreshPhotos(pAction: () => void): void {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark' ,'Loading...')
        );

        loading.Show(() => {
            let SelectedLangIDByHotelPhotoID: number[] = [];
            
            for (let i = 0; i < this.Photos.length; i++) {
                let photo: dmPhoto = this.Photos[i];
            
                SelectedLangIDByHotelPhotoID[photo.HotelPhotoID] = photo.LangID;
            }
            
            RQService.Ota.GetAllHotelPhotosAndDescriptions(
                this.AllPhotosParams
            ).then((result) => {
                let response = result as any;
            
                if (response.HasErrorOrException) { return; }
            
                let photoEntries   = response.RQueryResult;
            
                this.Photos.length = 0;
            
                let currentHotelPhotoID: number  = 0;
                let currentPhoto:        dmPhoto = null;
            
                for (let i = 0; i < photoEntries.length; i++) {
                    let photoEntry = RQService.Ota.PopulateGetAllHotelPhotosAndDescriptionsRow(
                        photoEntries[i]
                    );
            
                    console.log('row push');
            
                    if (
                        (currentPhoto        == null)
                    ||  (currentHotelPhotoID != photoEntry.HotelPhotoID)
                    ) {
                        currentPhoto = new dmPhoto(
                             this.NewLoading
                            ,this.app
                            ,this.GetInAction
                            ,this.SetInAction
                            ,photoEntry
                        );
            
                        this.Photos.push(currentPhoto);
            
                        currentHotelPhotoID = currentPhoto.HotelPhotoID;
                    }
            
                    currentPhoto.AddDescription(photoEntry)
                }
            
                for (let i = 0; i < this.Photos.length; i++) {
                    let photo: dmPhoto = this.Photos[i];
            
                    if (SelectedLangIDByHotelPhotoID[photo.HotelPhotoID]) {
                        photo.ChangeDescriptionLangID(
                            SelectedLangIDByHotelPhotoID[photo.HotelPhotoID]
                        );
                    } else {
                        photo.ChangeDescriptionLangID(1);
                    }
                }
            
                loading.Dismiss();
            
                pAction();
            });
        });
    }

    public SetFileSelected(event: any) {
        if (event.target.files && event.target.files[0]) { this.FileSelected = true;  }
        else                                             { this.FileSelected = false; }
    }

    public AddPhoto() {
        if (this.GetInAction()) { return; }

        this.SetInAction(true);

        let loading = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            RQService.Extensions.UploadHotelPhoto(
                 'filepicker'
                ,(this.Hotel.ChainWantsHotelID > 0) ? this.Hotel.HotelID : 0
                ,(result: any) => {
                    let status = RQService.Extensions.PopulateUploadHotelPhotoRow(result[0]);
            
                    loading.Dismiss();
            
                    if (!status.FileUploadedOK) {
                        let title:   string = this.app.Text(
                             'FileUploadError'
                            ,'File Upload Error'
                        );
                        let message: string = this.app.Text(
                             'ErrorUploadingFile'
                            ,'Error Uploading File'
                        );
            
                        if (status.FileUploadErrorNo == 1) {
                            message = this.app.Text(
                                 'UnrecognisedFileExtension'
                                ,'Unrecognised file extension - must be one of: '
                                  + '.png .jpeg .jpg .gif .tiff .bmp'
                            );
                        }
            
                        if (
                            status.FileUploadErrorNo == 2
                        ||  status.FileUploadErrorNo == 13
                        ) {
                            message = this.app.Text(
                                 'CantSaveFile'
                                ,'Server could not save file - '
                                  + 'contact support@tobook.com for more info'
                            );
                        }
            
                        if (status.FileUploadErrorNo == 11) {
                            message = this.app.Text(
                                 'NoFileSelected'
                                ,'No file selected for upload'
                            );
                        }
            
                        if (status.FileUploadErrorNo == 12) {
                            message = this.app.Text(
                                 'SelectedFileTooLarge'
                                ,'The selected file is too large: max size is 20MB'
                            );
                        }
            
                        this.ShowAlert(title ,message);
            
                        this.SetInAction(false);
            
                        return;
                    }
            
                    let saving = this.NewLoading(
                        this.app.Text('SavingMark' ,'Saving...')
                    );
            
                    saving.Show(() => {
                        this.FileSelected         = false;
                       
                        let editDescriptionParams = RQParam.OtaEditHotelPhotoDescriptionParams();
                       
                        editDescriptionParams.HotelID      = this.Hotel.HotelID;
                        editDescriptionParams.HotelPhotoID = status.FileID;
                        editDescriptionParams.Description  = this.NewPhotoDescriptionEN;
                        editDescriptionParams.LangID       = 1;
                       
                        RQService.Ota.EditHotelPhotoDescription(
                            editDescriptionParams
                        ).then((result) => {
                            this.NewPhotoDescriptionEN = '';
                       
                            saving.Dismiss();
                       
                            this.refreshPhotos(() => {
                                this.SetInAction(false);

                                this.ScrollToBottom();
                            });
                        });
                    });
                }
            );
        });
    }

    public DeletePhoto(pHotelPhotoID: number) {
        if (this.GetInAction()) { return; }

        this.ShowConfirmation(
             this.app.Text(
                 'ConfirmDeleteAction'
                ,'Confirm Delete Action'
            )
            ,this.app.Text(
                 'ConfirmDeletePhoto'
                ,'Are you sure you want to delete this photo?'
            )
            ,() => {
                if (this.GetInAction()) { return; }

                this.SetInAction(true);

                let loading = this.NewLoading(
                    this.app.Text('DeletingMark' ,'Deleting...')
                );

                loading.Show(() => {
                    let deleteParams = RQParam.OtaDeleteHotelPhotoParams();
                    
                    deleteParams.HotelID      = this.Hotel.HotelID;
                    deleteParams.HotelPhotoID = pHotelPhotoID;
                    
                    RQService.Ota.DeleteHotelPhoto(deleteParams).then((result) => {
                        loading.Dismiss();
                    
                        this.refreshPhotos(() => {
                            this.SetInAction(false);
                        });
                    });
                });
            }
        );
    }

    public NudgePhoto(pHotelPhotoID: number ,pUp: boolean) {
        if (this.GetInAction()) { return; }

        this.SetInAction(true);

        let loading = this.NewLoading(
            this.app.Text('SavingMark' ,'Saving...')
        );

        loading.Show(() => {
            let nudgeParams = RQParam.OtaNudgeHotelPhotoSortOrderParams();
           
            nudgeParams.HotelID      = this.Hotel.HotelID;
            nudgeParams.HotelPhotoID = pHotelPhotoID;
            nudgeParams.Up           = (pUp) ? 1 : 0;
           
            RQService.Ota.NudgeHotelPhotoSortOrder(nudgeParams).then((result) => {
                loading.Dismiss();
           
                this.refreshPhotos(() => {
                    this.SetInAction(false);
                });
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/photos/xv-photos.ts